import { Button, ButtonGroup, Center } from '@chakra-ui/react';
import { Modal } from '@gamma/ui/overlay';
import { i18n } from '../../../../../../shared/localization';
import { LicenseComparisonTable } from '../../../LicenseComparisonTable';

const { compareLicense } = i18n.pages.licenseDashboard.licenseStatus.buttons;
const { licenseDetails } = i18n.pages.licenseDashboard;

interface LicenseComparisonProps {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
}

export const LicenseComparisonModal = ({
  isOpen,
  onClose,
  onOpen,
}: LicenseComparisonProps) => {
  return (
    <Modal
      title={licenseDetails}
      data-testid="license-comparison-modal"
      size="xl"
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      body={<LicenseComparisonTable />}
      footer={
        <ButtonGroup spacing={4}>
          <Button variant="solid" colorScheme="blue" onClick={onClose}>
            {i18n.buttons.close}
          </Button>
        </ButtonGroup>
      }
    >
      <Center>
        <Button
          color={'text.link'}
          textStyle={'body-md'}
          alignSelf={'flex-end'}
        >
          {compareLicense}
        </Button>
      </Center>
    </Modal>
  );
};
